import React from 'react';
import { Button } from 'antd';
import './_activateFinariumCard.less';
import { FinariumLogo } from 'IMAGE';
import PropTypes from 'prop-types';
import Spinner from '@atoms/spinner';

const ActivateFinariumCard = ({ activateAccess, firstLoginFinarium, isLoading }) => {
  const handleClick = () => {
    activateAccess('finarium');
  };

  // if (isLoading) {
  //   return (
  //     <div className='card-dashboard-finarium'>
  //       <div className='card-dashboard-finarium__content'>
  //         <Spinner />
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className='card-dashboard-finarium'>
      <div className='card-dashboard-finarium__content'>
        <div className='title'>
          <FinariumLogo height={50} width={150} />
          <div className='text'></div>
        </div>
        <div className='subtitle'>
          <span> The Global Crypto Payment Platform for Business </span>
        </div>
        <div className='description'>
          Experience transparency, reliability, and global reach — all in one crypto solution
        </div>
        <Button htmlType='submit' type={'dashed'} size={'large'} onClick={handleClick} block>
          {firstLoginFinarium ? 'Activate access' : 'Re-Login'}
        </Button>
      </div>
    </div>
  );
};

export default ActivateFinariumCard;

ActivateFinariumCard.propTypes = {
  activateAccess: PropTypes.func.isRequired,
};
